import './PrintLabel.scss';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Error from '../Error/Error';
import Printer from '../../api/controllers/Printer/Printer';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

// General PrintLabel Component
const PrintLabel = ({ packages, setModalOpen, jobs }) => {
  const [error, setError] = useState();
  const [printers, setPrinters] = useState();
  const [loading, setLoading] = useState();

  const getPrinters = () => {
    Printer.all({ category: 'label' })
      .then(response => {
        setPrinters(response.items);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const printLabels = printer => {
    const ids = packages.map(p => p.package.id);
    const printerId = printer.id;

    setLoading(true);
    Printer.printPackages(printerId, ids)
      .then(() => {
        setLoading(false);
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const printTheoretical = printer => {
    const printerId = printer.id;

    setLoading(true);
    Printer.printPotentialPackages(printerId, jobs)
      .then(() => {
        setLoading(false);
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const handleClick = printer => {
    if (packages) {
      printLabels(printer);
    }
    if (jobs) {
      printTheoretical(printer);
    }
  };

  useEffect(() => {
    getPrinters();
  }, []);

  return (
    <div className="print_label_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      {packages && (
        <div className="affected_packages">
          {packages.length > 0 &&
            `This action applies to ${
              packages.length > 3
                ? `${packages.length} packages`
                : `${packages[0]?.packageName}${
                    packages[1]
                      ? `${packages.length > 2 ? ',' : ' and'} ${packages[1].packageName}`
                      : ''
                  }${packages[2] ? ` and ${packages[2].packageName}` : ''}`
            } `}
        </div>
      )}
      {jobs && (
        <div className="affected_packages">
          Labels will be printed for the following jobs:
          <ul>
            {Object.keys(jobs).map(key => (
              <li key={key}>
                <b>{jobs[key][0]?.job?.jobReference}:</b>{' '}
                {jobs[key].map(assignment => assignment.quantity).reduce((a, b) => a + b, 0)} labels
              </li>
            ))}
          </ul>
          Note that these labels are
          <i> provisional</i>, and may need re-printing for jobs split across multiple collections
          or imports.
        </div>
      )}
      <div className="printer_list">
        {printers?.map(printer => (
          <div className="printer" key={printer.id} onClick={() => handleClick(printer)}>
            <div className="printer_name">{printer.name}</div>
            <div className="printer_type">{printer.systemName}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

PrintLabel.propTypes = {
  packages: PropTypes.array,
  jobs: PropTypes.object,
  setModalOpen: PropTypes.func,
};

export default PrintLabel;
